import {
  PROVIDER_DETAIL_TABS,
  ServiceProvider,
  StageKey,
} from "../../../utils/integrationConfigData";

interface ProviderDetailTabsProps {
  activeTab: string;
  onChange: (tabId: string) => void;
  provider?: ServiceProvider | null;
  showCptTab?: boolean;
}

const ProviderDetailTabs = ({
  activeTab,
  onChange,
  showCptTab = true,
}: ProviderDetailTabsProps) => {
  const tabs = showCptTab
    ? PROVIDER_DETAIL_TABS
    : PROVIDER_DETAIL_TABS.filter((tab) => tab.id !== "cpt");

  return (
    <div className="ic-detail-tabs" role="tablist" aria-label="Provider details">
      {tabs.map((tab) => {
        const stageKey = tab.stage as StageKey | undefined;
        const showDot = Boolean(stageKey);

        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={activeTab === tab.id}
            className={`ic-detail-tab ${activeTab === tab.id ? "active" : ""}`}
            onClick={() => onChange(tab.id)}
          >
            {showDot && stageKey && (
              <span className="ic-stage-dot" aria-hidden="true" />
            )}
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};

export default ProviderDetailTabs;

